import { TrackingEvent, TrackingEventTypes } from '@cinch-nx/shared-analytics'

export const usedCarsTabClickEvent = (): TrackingEvent => ({
  eventName: 'home-page-tab-click',
  type: TrackingEventTypes.ADOBE,
  data: {
    event: {
      name: 'click',
      category: 'hero',
      action: 'select',
      value: 'used cars tab select',
      label: 'used cars',
    },
  },
})

export const tabsNewCarsClickEvent = (): TrackingEvent => ({
  eventName: 'Click on the New Cars tab on homepage hero',
  type: TrackingEventTypes.ADOBE,
  data: {
    event: {
      name: 'click',
      category: 'hero',
      action: 'select',
      value: 'new cars tab select',
      label: 'new cars',
    },
  },
})
